import {useMemo, useRef, useState} from "react";
import debounce from "lodash/debounce";
import {Avatar, Button, Select, Spin} from "antd";
import {useStore} from "../../contexts/AppContext";

import {PlusOutlined} from "@ant-design/icons";


const DebounceSelect = ({fetchOptions, onUserCreate, onAddUsersToList, isIamViewer, debounceTimeout = 300, ...props}) => {
    const [fetching, setFetching] = useState(false);
    const [searchValue, setSearchValue] = useState('');
    const [selectedUsers, setSelectedUsers] = useState([])
    const fetchRef = useRef(0);
    const {users, setUsers} = useStore()
    const debounceFetcher = useMemo(() => {
        const loadOptions = value => {
            setSearchValue(value);
            fetchRef.current += 1;
            setUsers([]);
            setFetching(true);
            fetchOptions(value)
            setFetching(false);
        };
        return debounce(loadOptions, debounceTimeout);
    }, [fetchOptions, debounceTimeout, setUsers]);


    return (
        <Select
            labelInValue
            filterOption={false}
            onSearch={debounceFetcher}
            disabled={isIamViewer}
            notFoundContent={
                fetching ? (
                    <Spin size="small"/>
                ) : searchValue ? (
                    <div style={{padding: 8, textAlign: 'center'}}>
                        <div style={{marginBottom: 6}}>
                            Не найдено результатов по запросу:
                            <strong> “{searchValue}”</strong>
                        </div>
                        <Button
                            type="link"
                            onClick={async () => await onUserCreate(searchValue)}
                            style={{padding: 0}}
                        >
                            ➕ Создать пользователя "{searchValue}"
                        </Button>
                    </div>
                ) : (
                    'Введите имя для поиска'
                )
            }
            {...props}
            options={users}
            optionRender={option => (
                <div style={{display: 'flex', alignItems: 'center'}}>
                    {option.data.avatar &&
                        <Avatar src={'https://api.dicebear.com/7.x/miniavs/svg?seed=3'} style={{marginRight: 8}}/>}
                    {option.label}
                </div>
            )}
            suffixIcon={
                <Button
                    type="text"
                    icon={<PlusOutlined/>}
                    size="small"
                    disabled={isIamViewer}
                    onClick={() => {
                        onAddUsersToList(selectedUsers.map(u => u.value))
                        setSelectedUsers([])
                    }}
                />
            }
            onChange={(e) => setSelectedUsers(e)}
        />
    );
}

export default DebounceSelect;